module.exports = __webpack_public_path__ + "static/media/checkin-printer-b.b766556a.png";